import useSWR from 'swr'

import { accountUrls } from '@/config/urls/account'
import { get } from '@/utils/fetchers'

import { ApiResponse, WorkspaceUser } from '@/types/index.d'

export function useWorkspaceUser(
  workspaceId: string,
  userId: string
): ApiResponse<WorkspaceUser> {
  const url = accountUrls.getUser({
    workspaceId,
    userId,
  })
  const { data, error } = useSWR<WorkspaceUser>(url, get(url))
  return {
    data,
    error,
    isLoading: url && !data && !error,
  }
}
